var system = {};
module['exports'] = system;
system.mimeTypes = require("./mimeTypes");


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/system/index.js
// module id = 729
// module chunks = 0